import styled from 'styled-components';
import {
  Modal as SemanticModal,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const SubmitButton = styled(ButtonLayoutComponent)``;
const CancelButton = styled(ButtonLayoutComponent.Inverted)``;

const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ContentActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 30px;
`;

const ContentError = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
`;

const ContentField = styled.div`
  margin-top: 15px;
  width: 100%;
`;

const ContainerText = styled.div`
  flex-grow: 1;
`;

const Modal = styled(SemanticModal)``;

const Content = styled(SemanticModal.Content)`
  &&& {
    display: flex;
    flex-direction: column;
  }
`;

const ErrorMessage = styled(TextLayoutComponent)`
  color: red;
`;

const Title = styled(TextLayoutComponent.Title)`
  padding-bottom: 5px;
`;

const Text = styled(TextLayoutComponent)``;

const Error = styled.div`
  color: ${(props) => props.theme.color.textError};
  font-size: 12px;
  margin-bottom: 10px;
  margin-top: -10px;
`;

export {
  SubmitButton,
  CancelButton,
  ContentField,
  ContentActions,
  ContentError,
  ContainerText,
  Modal,
  Content,
  ContentRow,
  ErrorMessage,
  Title,
  Error,
  Text,
};
